import all from './all';
import update from './update';

export default {
  all,
  update,
};



// WEBPACK FOOTER //
// ./src/app/services/creditNoteReason/index.js